import { render, staticRenderFns } from "./EditarMensajeModal.vue?vue&type=template&id=d8b0328a&"
import script from "./EditarMensajeModal.vue?vue&type=script&lang=ts&"
export * from "./EditarMensajeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports